// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"792cdeb5","230":"2d26ef18","238":"039f75d3","407":"ab55f5da","726":"ac6066af","729":"04eb6101","828":"4a4b8547"}[chunkId] + ".chunk.js";
};